/* Shared capability metadata — imported by OrgIAM and OrgMembers to avoid duplication */

export const CAP_LABELS = {
  'org.members.view':             'View Members',
  'org.members.invite':           'Invite Members',
  'org.members.edit':             'Manage Members',
  'org.members.remove':           'Remove Members',
  'org.workspaces.view':          'View Workspaces',
  'org.workspaces.create':        'Create Workspaces',
  'org.workspaces.edit':          'Edit Workspaces',
  'org.workspaces.delete':        'Delete Workspaces',
  'org.roles.view':               'View Roles',
  'org.roles.create':             'Create Roles',
  'org.roles.edit':               'Edit Roles',
  'org.roles.delete':             'Delete Roles',
  'org.settings.view':            'View Settings',
  'org.settings.edit':            'Edit Settings',
  'org.branding.view':            'View Branding',
  'org.branding.edit':            'Edit Branding',
  'org.whitelabel.configure':     'Configure White Label',
  'org.audit.view':               'View Audit Log',
  'org.audit.export':             'Export Audit Log',
  'org.analytics.view':           'View Analytics',
  'org.analytics.export':         'Export Analytics',
  'org.security.view':            'View Security Settings',
  'org.security.configure':       'Configure Security',
  'org.support.view':             'View Support',
  'org.support.create':           'Create Support Tickets',
  'org.usage.view':               'View Usage',
  'org.backup.view':              'View Backups',
  'org.backup.create':            'Create Backups',
  'org.backup.restore':           'Restore Backups',
  'org.search.use':               'Global Search',
  'org.health.view':              'View System Health',
  'org.templates.view':           'View Role Templates',
  'org.templates.create':         'Create Role Templates',
  'org.licenses.view':            'View Licenses',
  'analytics.org.users':          'Org User Analytics',
  'analytics.org.export':         'Export Org Analytics',
  'analytics.workspace.view':     'Workspace Analytics',
  'analytics.crm.basic':          'Basic CRM Analytics',
  'analytics.crm.advanced':       'Advanced CRM Analytics',
  'ws.view':                      'View Workspace',
  'ws.settings.edit':             'Edit Workspace Settings',
  'ws.assignments.view':          'View Workspace Assignments',
  'ws.assignments.manage':        'Manage Workspace Assignments',
  'crm.people.view':              'View Contacts',
  'crm.people.create':            'Create Contacts',
  'crm.people.edit':              'Edit Contacts',
  'crm.people.delete':            'Delete Contacts',
  'crm.companies.view':           'View Companies',
  'crm.companies.create':         'Create Companies',
  'crm.companies.edit':           'Edit Companies',
  'crm.companies.delete':         'Delete Companies',
  'crm.deals.view':               'View Deals',
  'crm.deals.create':             'Create Deals',
  'crm.deals.edit':               'Edit Deals',
  'crm.deals.delete':             'Delete Deals',
  'crm.deals.stage':              'Move Deal Stages',
  'crm.tasks.view':               'View Tasks',
  'crm.tasks.create':             'Create Tasks',
  'crm.tasks.edit':               'Edit Tasks',
  'crm.tasks.assign':             'Assign Tasks',
  'crm.activities.view':          'View Activities',
  'crm.activities.create':        'Log Activities',
  'crm.documents.view':           'View Documents',
  'crm.documents.upload':         'Upload Documents',
  'channels.email.use':           'Send Emails',
  'developer.api-keys.view':      'View API Keys',
  'developer.api-keys.create':    'Create API Keys',
  'developer.api-keys.delete':    'Delete API Keys',
  'developer.webhooks.view':      'View Webhooks',
  'developer.webhooks.create':    'Create Webhooks',
  'developer.webhooks.delete':    'Delete Webhooks',
  'developer.sdk.access':         'SDK Access',
  'ai.copilot.use':               'Use AI Copilot',
  'ai.email-assist.use':          'AI Email Assistant',
  'ai.agents.configure':          'Configure AI Agents',
  'ai.knowledge-base.create':     'Manage Knowledge Base',
  'ai.models.configure':          'Configure AI Models',
};

export const CAP_GROUP_LABELS = {
  org:       'Organization',
  ws:        'Workspace',
  crm:       'CRM',
  channels:  'Channels',
  developer: 'Developer',
  ai:        'AI Platform',
  analytics: 'Analytics',
  plan:      'Plans & Billing',
  audit:     'Audit & Compliance',
  member:    'Membership',
};

export function groupCapabilities(caps) {
  const groups = {};
  caps.forEach((c) => {
    const prefix = c.split('.')[0];
    if (!groups[prefix]) groups[prefix] = [];
    groups[prefix].push(c);
  });
  return groups;
}
